import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, OnInit, Renderer2 } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { TegelModule } from '@scania/tegel-angular-17';
import { UserService } from './shared/services/user-info.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterModule, RouterOutlet, CommonModule, TegelModule],
})
export class AppComponent implements OnInit {
  title = 'front-end-template';
  constructor(private renderer: Renderer2,
              private userService: UserService
  ){}

  ngOnInit(): void {
    if (window.location.host.indexOf('localhost') > -1){
      this.renderer.setAttribute(document.body, 'data-env', 'DEV');
    } else if (window.location.host.indexOf('dev-') > -1){
      this.renderer.setAttribute(document.body, 'data-env', 'DEV');
    } else if (window.location.host.indexOf('acp-') > -1){
      this.renderer.setAttribute(document.body, 'data-env', 'ACP');
    }

    // this.userService.getFfsDatabase().subscribe((result) => {
    //   localStorage.setItem('ffsDatabase', result);
    // });
    
  }
}
